import { openBlock as t, createElementBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return t(), n("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M5.778 4A1.79 1.79 0 0 0 4 5.778v12.444A1.79 1.79 0 0 0 5.778 20h12.444A1.79 1.79 0 0 0 20 18.222V12h-1.778v6.222H5.778V5.778H12V4zm8 0v1.778h3.187l-8.26 8.26 1.257 1.257 8.26-8.26v3.187H20V4z"
    }, null, -1)
  ])]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
